import React from 'react'
import customize from '../../Assets/customize.png'
import './home.styles.scss'
import { Button } from '@mui/material'
import { ReactComponent as Cart } from '../../Assets/cart.svg'
import { ReactComponent as Right } from '../../Assets/arrow-right.svg'
import VideoContainer from '../Video/VideoContainer'
import Partnership from '../Partnership/Partnership'
import Ending from '../../Components/Ending/Ending'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'

const Home = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className='container' aria-label="Pagina principale - Home">
            <Helmet>
                <meta itemProp="name" content="home" />
                <meta itemProp='description' content="IL FUTURO DEL RETAIL E’ GIA’ QUI. Offri ai tuoi clienti una nuova esperienza d'acquisto più coinvolgente e performante." />
            </Helmet>
            <div className='big' aria-label="Sezione introduttiva">
                <div className='text'>
                    <label className='title' aria-label={t("home.title")}>{t("home.title")}</label>
                    <label className='subtitle' aria-label={t("home.subtitle")}>{t("home.subtitle")}</label>
                </div>
            </div>
            <div className='ourProducts' aria-label="Presentazione prodotto SmartBip">
                <label className='desktop' aria-label={`${t("home.smartbip1")} ${t("home.smartbip2")} ${t("home.smartbip3")}`}>
                    {t("home.smartbip1")}<br />
                    {t("home.smartbip2")}<br />
                    <b>{t("home.smartbip3")}</b>
                </label>
                <label className='mobile' aria-label={`${t("home.smartbip1")} ${t("home.smartbip2")} ${t("home.smartbip3")}`}>
                    {t("home.smartbip1")}&nbsp;
                    {t("home.smartbip2")}&nbsp;
                    <b>{t("home.smartbip3")}</b>
                </label>
                <label style={{ fontSize: '22px' }} aria-label={t("home.smartbip.find")}>
                    {t("home.smartbip.find")}<br />
                    <Button
                        variant='text'
                        onClick={() => navigate('/smartbip')}
                        aria-label={`${t("discover")} SmartBip`}
                    >
                        {t("discover")} <Right />
                    </Button>
                </label>
            </div>
            <div className='giant' aria-label="Dettagli su SmartBip">
                <div className='image-sm' aria-hidden="true">
                    <Cart />
                </div>
                <div className='description'>
                    <div>
                        <label className='title' aria-label={t("home.smartbip.title1")}>{t("home.smartbip.title1")}</label>
                        <label className='subtitle' aria-label={t("home.smartbip.subtitle1")}>{t("home.smartbip.subtitle1")}</label>
                    </div>
                    <div>
                        <label className='title' aria-label={t("home.smartbip.title2")}>{t("home.smartbip.title2")}</label>
                        <label className='subtitle' aria-label={t("home.smartbip.subtitle2")}>{t("home.smartbip.subtitle2")}</label>
                    </div>
                    <div>
                        <label className='title' aria-label={t("home.smartbip.title3")}>{t("home.smartbip.title3")}</label>
                        <label className='subtitle' aria-label={t("home.smartbip.subtitle3")}>
                            {t("home.smartbip.subtitle3")}<br />
                            <Button
                                variant='text'
                                onClick={() => navigate('/smartbip')}
                                aria-label={`${t("discover")} SmartBip`}
                            >
                                {t("discover")} <Right />
                            </Button>
                        </label>
                    </div>
                </div>
                <div className='image' aria-hidden="true">
                    <Cart />
                </div>
            </div>
            <div className='giant' style={{ justifyContent: 'flex-end' }} aria-label="Sezione personalizzazione">
                <div className='image-sm'>
                    <img src={customize} alt="Illustrazione personalizzazione esperienza d'acquisto" />
                </div>
                <div className='image' style={{ left: '70px', right: 0 }}>
                    <img src={customize} alt="Illustrazione personalizzazione esperienza d'acquisto" />
                </div>
                <div className='description'>
                    <div>
                        <label className='title' aria-label={t("home.smartbip.title4")}>{t("home.smartbip.title4")}</label>
                        <label className='subtitle' aria-label={t("home.smartbip.subtitle4")}>{t("home.smartbip.subtitle4")}</label>
                    </div>
                    <div>
                        <label className='title' aria-label={t("home.smartbip.title5")}>{t("home.smartbip.title5")}</label>
                        <label className='subtitle' aria-label={t("home.smartbip.subtitle5")}>{t("home.smartbip.subtitle5")}</label>
                    </div>
                    <div>
                        <label className='title' aria-label={t("home.smartbip.title6")}>{t("home.smartbip.title6")}</label>
                        <label className='subtitle' aria-label={t("home.smartbip.subtitle6")}>
                            {t("home.smartbip.subtitle6")}<br />
                            <Button
                                variant='text'
                                onClick={() => navigate('/smartbip')}
                                aria-label={`${t("discover")} SmartBip`}
                            >
                                {t("discover")} <Right />
                            </Button>
                        </label>
                    </div>
                </div>
            </div>
            <VideoContainer aria-label="Video dimostrativo" />
            <Partnership aria-label="Sezione partner" />
            <Ending text={t("home.ending")} style={{ width: '100%' }} />
        </div>
    )
}

export default Home